var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useState } from 'react';
import '@cb/apricot/CBForm';
import cn from 'classnames';
import { useUID } from 'react-uid';
export const ToggleSwitch = (_a) => {
    var { switchId, descId, labelId, mainClassName, on, onLabel = 'On', offLabel = 'Off', labelPosition = 'right', ariaLabel, additionalDesc, additionalDescClass, onChange = () => { }, disabled = false, condensed = false, defaultOn } = _a, props = __rest(_a, ["switchId", "descId", "labelId", "mainClassName", "on", "onLabel", "offLabel", "labelPosition", "ariaLabel", "additionalDesc", "additionalDescClass", "onChange", "disabled", "condensed", "defaultOn"]);
    const switchRef = useRef(null);
    const [focused, setFocus] = useState(false);
    const uid = useUID();
    // eslint-disable-next-line no-param-reassign
    switchId = switchId || `apricot_switch_${uid}`;
    // eslint-disable-next-line no-param-reassign
    descId = additionalDesc && (descId || `apricot_des_${uid}`);
    const [uncontrolledOn, setUncontrolledOn] = useState(!!defaultOn);
    const isControlled = typeof on === 'boolean';
    const checked = isControlled ? on : uncontrolledOn;
    const label = onLabel && (React.createElement("label", { htmlFor: switchId, id: labelId }, checked ? onLabel : offLabel));
    return (React.createElement(React.Fragment, null,
        additionalDesc && (React.createElement("p", { id: descId, className: additionalDescClass }, additionalDesc)),
        React.createElement("div", { className: cn('cb-toggle-switch', condensed && 'cb-condensed', labelPosition === 'left' && 'cb-label-left cb-width-100', mainClassName), "data-cbtrack-comp": "apricot-react:toggles-switch" },
            labelPosition === 'left' && label,
            React.createElement("div", { className: cn('cb-switch', checked && 'cb-checked', focused && 'cb-focus', disabled && 'cb-disabled'), ref: switchRef },
                React.createElement("div", { className: "cb-switch-track" }),
                React.createElement("div", { className: "cb-switch-wrap" },
                    React.createElement("div", { className: "cb-switch-thumb" },
                        React.createElement("input", Object.assign({ type: "checkbox", id: switchId, role: "switch", disabled: disabled, checked: checked, "aria-checked": checked ? 'true' : 'false', "aria-label": ariaLabel, onBlur: () => {
                                setFocus(false);
                            }, onFocus: () => {
                                setFocus(true);
                            }, "aria-labelledby": descId && `${descId} ${switchId}`, onChange: e => {
                                if (onChange) {
                                    onChange(e.target.checked);
                                }
                                if (!isControlled) {
                                    setUncontrolledOn(e.target.checked);
                                }
                            } }, props))))),
            labelPosition !== 'left' && label)));
};
//# sourceMappingURL=ToggleSwitch.js.map